import { render } from "./Notice_Pending_Payment_Requests.vue?vue&type=template&id=1b0cfa40"
import script from "./Notice_Pending_Payment_Requests.vue?vue&type=script&lang=js"
export * from "./Notice_Pending_Payment_Requests.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__